export default {
  API_BASE_URL: "http://54.161.177.77:3000/api/v1",
  IMG_BASE_URL: "http://localhost:4000/",
  SOCKET_URL: "http://localhost:4000",
  TOKEN:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InRlc3RAdmlwcHMuY29tIiwiaWQiOjMsInJvbGUiOiJ1c2VyIiwiaWF0IjoxNjkwMjgwMDM1LCJleHAiOjE2OTIyNjcyMzV9.TGEJdqlSjWSiRxPaZT6UKnS1-UtQpJqbuyjRTyFQFXI",
  PAGINATOR_SIZE: 10,
};
